/*
 * This contains the Role Based Access Control (RBAC) rules for the app
 * https://auth0.com/blog/role-based-access-control-rbac-and-react-apps/#Introduction-to-Role-Based-Access-Control
 */
export const rules: Record<string, any> = {
  GENERAL_USER: {
    static: [],
  },
  ADMIN_USER: {
    static: ['applicationmanagement:visit', 'activitylog:view'],
  },
  SUPER_USER: {
    static: ['applicationmanagement:visit', 'activitylog:view'],
  },
};
